import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposSocioConstant } from 'constants/index'

const TipoSocio = ({ iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' md={12} />
      <Col md={12}>
        <Field name='tipoSocio'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-flujoEfectivo'
              disabled
              isInvalid={iTouched && iError}
            >
              <option value=''>Seleccionar</option>
              {TiposSocioConstant.__array.map(x => (
                <option value={x.id}>{x.nombre}</option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoSocio)
